import { atom } from "jotai";

export const selectedGroupAtom = atom<string | undefined>(undefined);
